import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { convertPercentage } from "../../../../util/targetCalc";

const TargetCorrSection = (props) => {
	const convPer = convertPercentage;

	const register = props.register;
	const isEditMode = props.isEditMode;
	const setValue = props.setValue;
	const watch = props.watch;
	const data = props.data;

	const TACorr = watch("TA_correction", convPer(data.TA_correction));
	const GACorr = watch("GA_correction", convPer(data.GA_correction));
	const otherCorr = watch("other_corrections", convPer(data.other_corrections));
	const [errors, setErrors] = useState({});

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) =>
		setValue(inputName, evt.target.value);

	useEffect(() => {
		const corrArray = [TACorr, GACorr, otherCorr];

		// Sum up the corrections
		const summedCorr = corrArray.reduce(
			(a, b) => parseFloat(a) + parseFloat(b)
		);

		props.setTotalCorr(summedCorr);
	}, [TACorr, GACorr, otherCorr]);

	useEffect(() => {
		setErrors(props.errors);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>Losses Assumptions</h5>
			<hr />
			<Row>
				<Col md="4">
					<Col md="6">
						<label htmlFor="TA_correction">TA Loss (%)</label>
						{errors.TA_correction &&
							errors.TA_correction.type == "required" && (
								<span className="required">*required</span>
							)}
					</Col>
					<Col md="4">
						<input
							type="number"
							step="0.01"
							ref={register}
							name="TA_correction"
							defaultValue={TACorr}
							readOnly={!isEditMode}
							onChange={(evt) => handleChange(evt, "TA_correction")}
						></input>
					</Col>
				</Col>
				<Col md="4">
					<Col md="6">
						<label htmlFor="GA_correction">GA Loss (%)</label>
						{errors.GA_correction &&
							errors.GA_correction.type == "required" && (
								<span className="required">*required</span>
							)}
					</Col>
					<Col md="4">
						<input
							type="number"
							step="0.01"
							ref={register}
							name="GA_correction"
							defaultValue={GACorr}
							readOnly={!isEditMode}
							onChange={(evt) => handleChange(evt, "GA_correction")}
						></input>
					</Col>
				</Col>
				<Col md="4">
					<Col md="6">
						<label htmlFor="other_corrections">Other Losses (%)</label>
						{errors.other_corrections &&
							errors.other_corrections.type == "required" && (
								<span className="required">*required</span>
							)}
					</Col>
					<Col md="4">
						<input
							type="number"
							step="0.01"
							ref={register}
							name="other_corrections"
							defaultValue={otherCorr}
							readOnly={!isEditMode}
							onChange={(evt) => handleChange(evt, "other_corrections")}
						></input>
					</Col>
				</Col>
			</Row>
		</>
	);
};

export default TargetCorrSection;
